import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: ${({ marginTop }) => marginTop || '48px'};
  padding: 48px 42px;
  border-top: ${({ hideBorder }) =>
    hideBorder ? 'none' : `1px solid ${themeStyle.varInkLight}`};
  width: 100%;
`;
